import { useQuery } from "@tanstack/react-query";
import { mapInfractionSummary } from "../handlers/map-infraction-summary";
import { getInfractionsSummary } from "../services/infractions.service";
import type { InfractionMetricsSummary } from "../types/infraction.types";
import { infractionQueryKeys } from "./infraction-query-keys";

export function useInfractionsSummary() {
	return useQuery<InfractionMetricsSummary>({
		queryKey: infractionQueryKeys.summary(),
		queryFn: async () => {
			const response = await getInfractionsSummary();
			return mapInfractionSummary(response);
		},
	});
}
